/* eslint-disable react/prop-types */
import React from 'react';
import { Card, CardContent } from '../ui/card';

interface VideoBlockProps {
  title: string;
  summary: string;
  views: string;
  timestamp: string;
  userProfile: string;
  channelName: string;
}

const VideoBlock: React.FC<VideoBlockProps> = React.memo(({
  title,
  summary,
  views,
  timestamp,
  userProfile,
  channelName,
}) => {
  return (
    <Card className="bg-gray-900 border-gray-700 hover:bg-gray-800 transition-colors">
      <CardContent className="p-0">
        <div className="flex flex-col sm:flex-row gap-4 p-4">
          {/* Thumbnail */}
          <div className="relative aspect-video w-full sm:w-80 bg-gray-800 rounded-lg overflow-hidden flex-shrink-0">
            <p className="bg-black text-white text-xs font-semibold absolute bottom-2 right-2 p-1 rounded-md">
              10:01
            </p>
          </div>

          {/* Video Info */}
          <div className="flex-1 min-w-0">
            <h2 className="text-white text-xl font-bold mb-2 break-words line-clamp-2">
              {title}
            </h2>
            <p className="text-gray-400 text-sm mb-2">
              {views} · {timestamp}
            </p>
            <div className="flex items-center mb-2">
              <img
                className="w-7 h-7 rounded-full mr-2"
                src={userProfile}
                alt={`${channelName} profile`}
              />
              <p className="text-white text-sm">{channelName}</p>
              <svg className="ml-1 h-4 w-4 flex-shrink-0" viewBox="0 0 24 24" fill="white">
                <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM9.8 17.3l-4.2-4.1L7 11.8l2.8 2.7L17 7.4l1.4 1.4-8.6 8.5z" />
              </svg>
            </div>
            <p className="text-gray-300 text-sm line-clamp-2">{summary}..</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});

VideoBlock.displayName = 'VideoBlock';

export default VideoBlock;
